<template>
  <a-modal
    :title="`${isEdit ? '编辑' : '添加'}商品`"
    :confirm-loading="confirmLoading"
    @ok="confirm"
    v-model="show"
    :afterClose="
      () => {
        $emit('close');
      }
    "
  >
    <a-form-model ref="form" :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item label="关联路线" prop="service_id" :rules="[{ required: true, message: '请输入' }]">
        <a-select v-model="form.service_id">
          <a-select-option v-for="val in options" :value="val.id">{{ val.line_place }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="物品名称" prop="goods_name" :rules="[{ required: true, message: '请输入' }]">
        <a-input v-model="form.goods_name" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import Service from '@/api/service';
export default {
  name: 'EditModal',
  props: {
    show: Boolean,
    detail: Object,
    options: Array,
    service_id: String,
  },
  data() {
    return {
      confirmLoading: false,
      Visible: false,
      form: {
        goods_id: 1,
        service_id: '',
        goods_name: '',
      },
    };
  },
  computed: {
    isEdit() {
      return this.detail.id ? true : false;
    },
  },
  watch: {
    service_id(res) {
      this.form.service_id = res;
    },
    detail(res) {
      res.goods_id = parseInt(res.goods_id);
      this.form = res;
    },
  },
  created() {},
  methods: {
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.confirmLoading = true;
          Service.addGoods(this.form).then(res => {
            this.confirmLoading = false;
            if (res.code == 0) {
              this.form = {
                goods_id: 1,
                service_id: '',
                goods_name: '',
              };
              this.$emit('close');
              this.$emit('success');
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
  mounted() {},
};
</script>
